import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipe } from './filter.pipe';
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ FilterPipe],
  exports:[FilterPipe]
})
export class FilterModule { }


// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/pipes/filter.module.ts